import { Linkedin, Mail, MapPin } from "lucide-react";
import { NAV_LINKS, CONTACT, LEADERSHIP, IMAGES } from "../mock";

export default function Footer() {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  const year = new Date().getFullYear();

  return (
    <footer className="relative border-t border-teal-500/10 bg-[#040e0d] pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <img src={IMAGES.logo} alt="GBB LLC - Golden Bridge Business" className="h-24 w-auto object-contain" />
            </div>
            <p className="mt-5 text-sm text-slate-400 leading-relaxed max-w-sm">
              Golden Bridge Business LLC {"\u2014"} architecting capital clarity, liquid intelligence, and sustainable compute across Oman and the GCC region.
            </p>
            <a
              href={LEADERSHIP.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-flex items-center gap-2 text-sm text-teal-300 hover:text-teal-200 transition-colors"
            >
              <Linkedin size={16} /> Connect on LinkedIn
            </a>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white text-sm uppercase tracking-wider">Navigate</h4>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    onClick={(e) => { e.preventDefault(); scrollTo(l.href); }}
                    className="text-sm text-slate-400 hover:text-teal-300 transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white text-sm uppercase tracking-wider">Contact</h4>
            <ul className="mt-5 space-y-4">
              <li className="flex items-start gap-3 text-sm text-slate-400">
                <MapPin size={16} className="mt-0.5 text-teal-400 shrink-0" /> {CONTACT.address}
              </li>
              <li className="flex items-start gap-3 text-sm text-slate-400">
                <Mail size={16} className="mt-0.5 text-teal-400 shrink-0" />
                <a href={`mailto:${CONTACT.email}`} className="hover:text-teal-300 transition-colors break-all">{CONTACT.email}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-teal-500/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">{"\u00a9"} {year} Golden Bridge Business LLC. All rights reserved.</p>
          <p className="text-xs text-slate-500">Muscat {"\u2022"} Sultanate of Oman</p>
        </div>
      </div>
    </footer>
  );
}